import React from "react";
import SITE from "../services/siteConfig";

export default function PrivacyPolicy() {
  const P = { color: "var(--text-secondary)", fontSize: "0.85rem", lineHeight: 1.7, margin: "0 0 0.75rem 0" };
  const H = { color: "var(--text-primary)", fontSize: "1.1rem", fontWeight: 700, margin: "1.5rem 0 0.5rem 0" };

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg-secondary)", display: "flex", justifyContent: "center", padding: "2rem 1rem" }}>
      <div style={{ maxWidth: 780, width: "100%", background: "var(--bg-card)", borderRadius: "var(--radius-lg)", border: "1px solid var(--border)", padding: "2.5rem 2rem", boxShadow: "var(--shadow-md)" }}>
        <h1 style={{...H, fontSize:"1.5rem", margin:"0 0 0.25rem 0"}}>Privacy Policy</h1>
        <p style={P}>Last updated: {new Date().getFullYear()}</p>

        <h2 style={H}>1. Information We Collect</h2>
        <p style={P}><strong>Personal ID:</strong> Full name, date of birth, government ID, address, email, phone, photographs of ID documents.</p>
        <p style={P}><strong>Financial:</strong> Bank account details, credit/debit card info, transaction history, account balances, payment records.</p>
        <p style={P}><strong>Technical:</strong> IP addresses, device info, browser type, access times, pages visited, cookies.</p>

        <h2 style={H}>2. How We Use Your Information</h2>
        <p style={P}>Process transactions, verify identities, facilitate escrow services, manage accounts, prevent fraud, improve services, and send necessary notifications.</p>

        <h2 style={H}>3. Information Sharing</h2>
        <p style={P}>With payment processors, banking partners, identity verification services, cloud providers, and as required by law (court orders, regulatory requirements).</p>

        <h2 style={H}>4. Data Security</h2>
        <p style={P}>Encryption in transit and at rest, secure server infrastructure, access controls, regular security audits, employee training, incident response procedures.</p>

        <h2 style={H}>5. Your Rights</h2>
        <p style={P}>Access, review, download, and update your personal information. Manage communication preferences. Opt-out of marketing. Delete account subject to legal requirements.</p>

        <h2 style={H}>6. Contact</h2>
        <p style={P}>Email: {SITE.email} | Phone: {SITE.phone}</p>

        <p style={{ textAlign: "center", marginTop: "2rem", paddingTop: "1.5rem", borderTop: "1px solid var(--border)", color: "var(--text-muted)", fontSize: "0.78rem" }}>
          By using our services, you acknowledge reading and understanding this Privacy Policy.
        </p>
      </div>
    </div>
  );
}